<template>
  <div>
    <ts-card>
      <div class="form-header ts-bg-gray-100 ts-border-b ts-border-gray-400 ts-p-4 ts-relative">
        <h4 class="ts-text-sm">{{ $t('payrollTemplate.pageTitle') }}</h4>
        <ts-modal-close-button />
      </div>
    </ts-card>
    <ts-card-wrapper>
      <form class="form-horizontal">
        <div class="row">
          <div class="col-md-4 ts-border-r-4">
            <div class="ts-bg-gray-100 ts-border-b ts-border-gray-400 ts-p-2 ts-relative ts-text-blue-700">
              <b>{{ $t('payrollTemplate.displaySetting') }}</b>
            </div>
            <div class="row form-group m-b-15 mt-2">
              <label class="col-md-4 col-form-label text-left required">{{ $t('payrollTemplate.templateName') }}</label>
              <div class="col-md-8">
                <input
                  type="text"
                  class="form-control"
                  :class="{ 'is-invalid': errors.has('template_name') }"
                  v-model="model.template_name"
                />
                <div class="invalid-feedback" v-if="errors.has('template_name')">
                  {{ errors.first('template_name') }}
                </div>
              </div>
            </div>
            <div class="row form-group m-b-15">
              <label class="col-md-4 col-form-label text-left required">{{ $t('payrollTemplate.rowStart') }}</label>
              <div class="col-md-8">
                <input
                  type="number"
                  class="form-control"
                  :class="{ 'is-invalid': errors.has('excel_row_start') }"
                  v-model.number="model.excel_row_start"
                />
                <div class="invalid-feedback" v-if="errors.has('excel_row_start')">
                  {{ errors.first('excel_row_start') }}
                </div>
              </div>
            </div>
            <div class="row form-group m-b-15">
              <label class="col-md-4 col-form-label text-left required">{{ $t('payrollTemplate.columnStart') }}</label>
              <div class="col-md-8">
                <input
                  type="number"
                  class="form-control"
                  :class="{ 'is-invalid': errors.has('excel_column_start') }"
                  v-model.number="model.excel_column_start"
                />
                <div class="invalid-feedback" v-if="errors.has('excel_column_start')">
                  {{ errors.first('excel_column_start') }}
                </div>
              </div>
            </div>
            <div class="row form-group m-b-15">
              <label class="col-md-4 col-form-label text-left">{{ $t('payrollTemplate.groupBy') }}</label>
              <div class="col-md-8">
                <select
                  class="form-control"
                  :class="{ 'is-invalid': errors.has('group_by_column') }"
                  v-model.number="model.group_by_column"
                >
                  <option value="">{{ $t('select') }}</option>
                  <option v-for="(item, index) in groupByVariableBounded" :key="index" :value="item.value">
                    {{ item.text }}
                  </option>
                </select>
                <div class="invalid-feedback" v-if="errors.has('group_by_column')">
                  {{ errors.first('group_by_column') }}
                </div>
              </div>
            </div>
            <div class="row form-group m-b-15">
              <label class="col-md-4 col-form-label text-left required">{{ $t('payrollTemplate.templateType') }}</label>
              <div class="col-md-8">
                <select
                  class="form-control"
                  :class="{ 'is-invalid': errors.has('template_type') }"
                  v-model.number="model.template_type"
                >
                  <option value="">{{ $t('select') }}</option>
                  <option value="Payroll">Payroll</option>
                  <option value="Others">Others</option>
                </select>
                <div class="invalid-feedback" v-if="errors.has('template_type')">
                  {{ errors.first('template_type') }}
                </div>
              </div>
            </div>
            <div class="row form-group m-b-15">
              <label class="col-md-4 col-form-label text-left required">{{ $t('payrollTemplate.autoId') }}</label>
              <div class="col-md-8">
                <ts-checkbox v-model="model.include_auto_number" :disabled="true"></ts-checkbox>
                <div class="invalid-feedback" v-if="errors.has('include_auto_number')">
                  {{ errors.first('include_auto_number') }}
                </div>
              </div>
            </div>
            <div>
              <h5 class="ts-py-3 ts-border-b ts-text-blue-700">
                <b>{{ $t('payrollTemplate.headerReport') }}</b>
              </h5>
              <div class="row mt-2">
                <div class="col-md-4">
                  <label class="col-form-label text-left ml-2">{{ $t('payrollTemplate.isCaption1') }}</label>
                </div>
                <div class="col-md-8">
                  <ts-checkbox v-model="model.is_caption1"></ts-checkbox>
                </div>
              </div>
              <div class="row ts-my-2">
                <div class="col-md-4">
                  <label class="col-form-label text-left ml-2">{{ $t('payrollTemplate.caption1') }}</label>
                </div>
                <div class="col-md-8">
                  <input
                    type="text"
                    v-model="model.caption1"
                    class="form-control"
                    :class="{ 'is-invalid': errors.has('caption1') }"
                    :disabled="!model.is_caption1"
                  />
                  <div class="invalid-feedback" v-if="errors.has('caption1')">
                    {{ errors.first('caption1') }}
                  </div>
                </div>
              </div>
              <div class="row m-b-15">
                <div class="col-md-4">
                  <label class="col-form-label text-left ml-2">{{ $t('payrollTemplate.caption1Cell') }}</label>
                </div>
                <div class="col-md-8">
                  <input
                    type="text"
                    v-model="model.caption1_cell"
                    class="form-control"
                    :class="{ 'is-invalid': errors.has('caption1_cell') }"
                    :disabled="!model.is_caption1"
                    @input="model.caption1_cell = $event.target.value.toUpperCase()"
                  />
                  <div class="invalid-feedback" v-if="errors.has('caption1_cell')">
                    {{ errors.first('caption1_cell') }}
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-4">
                  <label class="col-form-label text-left ml-2">{{ $t('payrollTemplate.isCaption2') }}</label>
                </div>
                <div class="col-md-8">
                  <ts-checkbox v-model="model.is_caption2"></ts-checkbox>
                </div>
              </div>
              <div class="row ts-my-2">
                <div class="col-md-4">
                  <label class="col-form-label text-left ml-2">{{ $t('payrollTemplate.caption2') }}</label>
                </div>
                <div class="col-md-8">
                  <input
                    type="text"
                    v-model="model.caption2"
                    class="form-control"
                    :class="{ 'is-invalid': errors.has('caption2') }"
                    :disabled="!model.is_caption2"
                  />
                  <div class="invalid-feedback" v-if="errors.has('caption2')">
                    {{ errors.first('caption2') }}
                  </div>
                </div>
              </div>
              <div class="row m-b-15">
                <div class="col-md-4">
                  <label class="col-form-label text-left ml-2">{{ $t('payrollTemplate.caption2Cell') }}</label>
                </div>
                <div class="col-md-8">
                  <input
                    type="text"
                    v-model="model.caption2_cell"
                    class="form-control"
                    :class="{ 'is-invalid': errors.has('caption2_cell') }"
                    :disabled="!model.is_caption2"
                    @input="model.caption2_cell = $event.target.value.toUpperCase()"
                  />
                  <div class="invalid-feedback" v-if="errors.has('caption2_cell')">
                    {{ errors.first('caption2_cell') }}
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-4">
                  <label class="col-form-label text-left ml-2">{{ $t('payrollTemplate.isCaption3') }}</label>
                </div>
                <div class="col-md-8">
                  <ts-checkbox v-model="model.is_caption3"></ts-checkbox>
                </div>
              </div>
              <div class="row ts-my-2">
                <div class="col-md-4">
                  <label class="col-form-label text-left ml-2">{{ $t('payrollTemplate.caption3') }}</label>
                </div>
                <div class="col-md-8">
                  <input
                    type="text"
                    v-model="model.caption3"
                    class="form-control"
                    :class="{ 'is-invalid': errors.has('caption3') }"
                    :disabled="!model.is_caption3"
                  />
                  <div class="invalid-feedback" v-if="errors.has('caption3')">
                    {{ errors.first('caption3') }}
                  </div>
                </div>
              </div>
              <div class="row m-b-15">
                <div class="col-md-4">
                  <label class="col-form-label text-left ml-2">{{ $t('payrollTemplate.caption3Cell') }}</label>
                </div>
                <div class="col-md-8">
                  <input
                    type="text"
                    v-model="model.caption3_cell"
                    class="form-control"
                    :class="{ 'is-invalid': errors.has('caption3_cell') }"
                    :disabled="!model.is_caption3"
                    @input="model.caption3_cell = $event.target.value.toUpperCase()"
                  />
                  <div class="invalid-feedback" v-if="errors.has('caption3_cell')">
                    {{ errors.first('caption3_cell') }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-8">
            <variable-list v-model="model.template_detail" @sort="setNewSort"></variable-list>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-md-12 text-right">
            <ts-button class="mr-2" @click.prevent="$emit('close')">{{ $t('button.cancel') }}</ts-button>
            <ts-button class="btn-primary" :waiting="saving" @click.prevent="update" v-if="updating">{{
              $t('button.update')
            }}</ts-button>
            <ts-button class="btn-primary" :waiting="saving" @click.prevent="store" v-if="!updating">{{
              $t('button.save')
            }}</ts-button>
          </div>
        </div>
      </form>
    </ts-card-wrapper>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { Errors } from 'form-backend-validation'
import VariableList from './varible-list'

export default {
  name: 'payroll-template-form',
  props: ['editData'],
  components: {
    VariableList
  },
  data() {
    return {
      model: {
        template_id: '',
        template_name: '',
        excel_row_start: '',
        excel_column_start: '',
        include_auto_number: true,
        template_type: '',
        group_by_column: '',
        is_caption1: false,
        caption1: '',
        caption1_cell: '',
        is_caption2: false,
        caption2: '',
        caption2_cell: '',
        is_caption3: false,
        caption3: '',
        caption3_cell: '',
        template_detail: []
      },
      errors: new Errors(),
      saving: false,
      updating: false
    }
  },
  created() {
    this.setEditData()
  },
  computed: {
    groupByVariableBounded() {
      return this.$store.state.hr.payrollTemplate.userVariables
        .filter(v => v.nature === 'System')
        .map(g => ({
          value: g.display_name,
          text: g.display_name
        }))
    }
  },
  methods: {
    store() {
      this.errors = new Errors()
      this.saving = true
      this.$store
        .dispatch('hr/payrollTemplate/store', this.model)
        .then(response => {
          this.saving = false
          this.$toasted.success(response.message)
          this.$emit('close')
          this.fetchData()
        })
        .catch(error => {
          this.saving = false
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
        })
    },
    update() {
      this.errors = new Errors()
      this.saving = true
      this.$store
        .dispatch('hr/payrollTemplate/update', {
          id: this.editData.template_id,
          data: this.model
        })
        .then(response => {
          this.saving = false
          this.$toasted.success(response.message)
          this.$emit('close')
          this.fetchData()
        })
        .catch(error => {
          this.saving = false
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
        })
    },
    setEditData() {
      if (!_.isEmpty(this.editData) || !this.editData === undefined) {
        this.updating = true
        this.model = {
          template_id: this.editData.template_id,
          template_name: this.editData.template_name,
          excel_row_start: this.editData.excel_row_start,
          excel_column_start: this.editData.excel_column_start,
          include_auto_number: this.editData.include_auto_number,
          template_type: this.editData.template_type,
          group_by_column: this.editData.group_by_column ? this.editData.group_by_column : '',
          is_caption1: this.editData.is_caption1,
          caption1: this.editData.caption1,
          caption1_cell: this.editData.caption1_cell,
          is_caption2: this.editData.is_caption2,
          caption2: this.editData.caption2,
          caption2_cell: this.editData.caption2_cell,
          is_caption3: this.editData.is_caption3,
          caption3: this.editData.caption3,
          caption3_cell: this.editData.caption3_cell,
          template_detail: this.editData.details
        }
      }
    },
    fetchData() {
      this.$store.dispatch('hr/payrollTemplate/fetch').catch(error => {
        this.$toasted.error(error.message)
      })
    },
    setNewSort(value) {
      if (value.length > 0) {
        this.model.template_detail = value
      }
    }
  },
  watch: {
    'model.is_caption1': function(value) {
      if (!value) {
        this.model.caption1 = ''
        this.model.caption1_cell = ''
      }
    },
    'model.is_caption2': function(value) {
      if (!value) {
        this.model.caption2 = ''
        this.model.caption2_cell = ''
      }
    },
    'model.is_caption3': function(value) {
      if (!value) {
        this.model.caption3 = ''
        this.model.caption3_cell = ''
      }
    }
  }
}
</script>
